<template>
  <div class="relative">
    <a-carousel
      ref="carouselRef"
      :dots="false"
      :arrows="false"
      :infinite="false"
      :centerMode="false"
      :slidesToShow="slidesToShow"
      :slidesToScroll="slidesToShow"
      :style="{ width: `${slidesToShow * cardWidth}px` }"
      :afterChange="onAfterChange"
    >
      <slot />
    </a-carousel>
    <div v-if="currentIndex > 0" class="left-[-24px] slick-arrow" @click="carouselPrev">
      <iconpark-icon
        name="arrowright"
        class="text-[18px] text-font-30 rotate-[180deg] arrow"
      ></iconpark-icon>
    </div>
    <div
      v-if="currentIndex + slidesToShow < total"
      class="right-[-24px] slick-arrow"
      @click="carouselNext"
    >
      <iconpark-icon name="arrowright" class="text-[18px] text-font-30 arrow"></iconpark-icon>
    </div>
  </div>
</template>
<script lang="ts" setup>
const props = defineProps<{
  slidesToShow: number;
  cardWidth: number;
  next?: () => Promise<void>;
  total: number;
}>();

const carouselRef = ref();
const currentIndex = ref(0);
const onAfterChange = (current: number) => {
  currentIndex.value = current;
};

const carouselPrev = () => {
  carouselRef.value?.prev();
};

const carouselNext = async () => {
  if (props.next) {
    if (props.total <= currentIndex.value + props.slidesToShow) {
      await props.next();
    }
  }
  carouselRef.value?.next();
};

defineExpose({
  goTo(index: number) {
    carouselRef.value?.goTo(index);
  },
  reset() {
    currentIndex.value = 0;
  },
});
</script>
<style lang="scss" scoped>
.slick-arrow {
  @apply absolute top-1/2 -translate-y-1/2 w-[32px] h-[32px] flex-center rounded-[50%] backdrop-blur-[16px] cursor-pointer;
  z-index: 1;
  color: var(--text-1-30);
  border: 1px solid var(--back-3);
  background: var(--back-0);
  transition: all 0.1s ease;
  img {
    @apply w-[16px] h-[16px];
  }
  &:hover {
    .arrow {
      @apply text-primary;
    }
  }
}
</style>
